/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccountRouteImport } from './routes/account'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ForProsRouteImport } from './routes/for-pros'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as SearchRouteImport } from './routes/search'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AuthPhoneRouteImport } from './routes/auth/phone'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthSignInRouteImport } from './routes/auth/sign-in'
import { Route as AuthSignUpRouteImport } from './routes/auth/sign-up'
import { Route as BookingsIndexRouteImport } from './routes/bookings/index'
import { Route as BookingsIdRouteImport } from './routes/bookings/$id'
import { Route as BusinessesSlugRouteImport } from './routes/businesses/$slug'
import { Route as DashboardBusinessSlugRouteImport } from './routes/dashboard/$businessSlug'
import { Route as DashboardCalendarRouteImport } from './routes/dashboard/calendar'
import { Route as DashboardClientsRouteImport } from './routes/dashboard/clients'
import { Route as DashboardPosRouteImport } from './routes/dashboard/pos'
import { Route as DashboardSettingsRouteImport } from './routes/dashboard/settings'
import { Route as DiscoverIndexRouteImport } from './routes/discover/index'
import { Route as DiscoverCategoryRouteImport } from './routes/discover/$category'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index'
import { Route as OnboardingBusinessRouteImport } from './routes/onboarding/business'
import { Route as OnboardingCompleteRouteImport } from './routes/onboarding/complete'
import { Route as OnboardingLocationRouteImport } from './routes/onboarding/location'
import { Route as OnboardingNewRouteImport } from './routes/onboarding/new'
import { Route as OnboardingSelectBusinessRouteImport } from './routes/onboarding/select-business'
import { Route as OnboardingServicesRouteImport } from './routes/onboarding/services'
import { Route as OnboardingSignUpRouteImport } from './routes/onboarding/sign-up'
import { Route as OnboardingStartRouteImport } from './routes/onboarding/start'
import { Route as OnboardingTeamSizeRouteImport } from './routes/onboarding/team-size'
import { Route as OnboardingVerifyPhoneRouteImport } from './routes/onboarding/verify-phone'
import { Route as TeamInvitesAcceptRouteImport } from './routes/team-invites/accept'
import { Route as BookingsIdBookAgainRouteImport } from './routes/bookings/$id.book-again'
import { Route as BookingsIdRescheduleRouteImport } from './routes/bookings/$id.reschedule'
import { Route as BusinessesSlugBookRouteImport } from './routes/businesses/$slug.book'
import { Route as DashboardBusinessSlugCalendarRouteImport } from './routes/dashboard/$businessSlug/calendar'
import { Route as DashboardBusinessSlugClientsRouteImport } from './routes/dashboard/$businessSlug/clients'
import { Route as DashboardBusinessSlugPosRouteImport } from './routes/dashboard/$businessSlug/pos'
import { Route as DashboardBusinessSlugSettingsRouteImport } from './routes/dashboard/$businessSlug/settings'

const AuthCallbackLazyRouteImport = createFileRoute('/auth/callback')()
const DashboardIndexLazyRouteImport = createFileRoute('/dashboard/')()
const BookingsIdIndexLazyRouteImport = createFileRoute('/bookings/$id/')()
const DashboardBusinessSlugIndexLazyRouteImport = createFileRoute(
  '/dashboard/$businessSlug/',
)()

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/account.lazy').then((d) => d.Route))
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ForProsRoute = ForProsRouteImport.update({
  id: '/for-pros',
  path: '/for-pros',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/for-pros.lazy').then((d) => d.Route))
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/verify-email.lazy').then((d) => d.Route))
const AuthCallbackLazyRoute = AuthCallbackLazyRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/auth/callback.lazy').then((d) => d.Route))
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/auth/forgot-password',
  path: '/auth/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/auth/forgot-password.lazy').then((d) => d.Route),
)
const AuthPhoneRoute = AuthPhoneRouteImport.update({
  id: '/auth/phone',
  path: '/auth/phone',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/auth/phone.lazy').then((d) => d.Route))
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/auth/reset-password.lazy').then((d) => d.Route),
)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/auth/sign-in',
  path: '/auth/sign-in',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/auth/sign-in.lazy').then((d) => d.Route))
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/auth/sign-up',
  path: '/auth/sign-up',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/auth/sign-up.lazy').then((d) => d.Route))
const BookingsIndexRoute = BookingsIndexRouteImport.update({
  id: '/bookings/',
  path: '/bookings/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/bookings/index.lazy').then((d) => d.Route),
)
const BookingsIdRoute = BookingsIdRouteImport.update({
  id: '/bookings/$id',
  path: '/bookings/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessesSlugRoute = BusinessesSlugRouteImport.update({
  id: '/businesses/$slug',
  path: '/businesses/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexLazyRoute = DashboardIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/index.lazy').then((d) => d.Route),
)
const DashboardBusinessSlugRoute = DashboardBusinessSlugRouteImport.update({
  id: '/$businessSlug',
  path: '/$businessSlug',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCalendarRoute = DashboardCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/calendar.lazy').then((d) => d.Route),
)
const DashboardClientsRoute = DashboardClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/clients.lazy').then((d) => d.Route),
)
const DashboardPosRoute = DashboardPosRouteImport.update({
  id: '/pos',
  path: '/pos',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() => import('./routes/dashboard/pos.lazy').then((d) => d.Route))
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRoute,
} as any).lazy(() =>
  import('./routes/dashboard/settings.lazy').then((d) => d.Route),
)
const DiscoverIndexRoute = DiscoverIndexRouteImport.update({
  id: '/discover/',
  path: '/discover/',
  getParentRoute: () => rootRouteImport,
} as any)
const DiscoverCategoryRoute = DiscoverCategoryRouteImport.update({
  id: '/discover/$category',
  path: '/discover/$category',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OnboardingRoute,
} as any).lazy(() =>
  import('./routes/onboarding/index.lazy').then((d) => d.Route),
)
const OnboardingBusinessRoute = OnboardingBusinessRouteImport.update({
  id: '/business',
  path: '/business',
  getParentRoute: () => OnboardingRoute,
} as any).lazy(() =>
  import('./routes/onboarding/business.lazy').then((d) => d.Route),
)
const OnboardingCompleteRoute = OnboardingCompleteRouteImport.update({
  id: '/complete',
  path: '/complete',
  getParentRoute: () => OnboardingRoute,
} as any).lazy(() =>
  import('./routes/onboarding/complete.lazy').then((d) => d.Route),
)
const OnboardingLocationRoute = OnboardingLocationRouteImport.update({
  id: '/location',
  path: '/location',
  getParentRoute: () => OnboardingRoute,
} as any).lazy(() =>
  import('./routes/onboarding/location.lazy').then((d) => d.Route),
)
const OnboardingNewRoute = OnboardingNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingSelectBusinessRoute =
  OnboardingSelectBusinessRouteImport.update({
    id: '/select-business',
    path: '/select-business',
    getParentRoute: () => OnboardingRoute,
  } as any).lazy(() =>
    import('./routes/onboarding/select-business.lazy').then((d) => d.Route),
  )
const OnboardingServicesRoute = OnboardingServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => OnboardingRoute,
} as any).lazy(() =>
  import('./routes/onboarding/services.lazy').then((d) => d.Route),
)
const OnboardingSignUpRoute = OnboardingSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => OnboardingRoute,
} as any).lazy(() =>
  import('./routes/onboarding/sign-up.lazy').then((d) => d.Route),
)
const OnboardingStartRoute = OnboardingStartRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingTeamSizeRoute = OnboardingTeamSizeRouteImport.update({
  id: '/team-size',
  path: '/team-size',
  getParentRoute: () => OnboardingRoute,
} as any).lazy(() =>
  import('./routes/onboarding/team-size.lazy').then((d) => d.Route),
)
const OnboardingVerifyPhoneRoute = OnboardingVerifyPhoneRouteImport.update({
  id: '/verify-phone',
  path: '/verify-phone',
  getParentRoute: () => OnboardingRoute,
} as any).lazy(() =>
  import('./routes/onboarding/verify-phone.lazy').then((d) => d.Route),
)
const TeamInvitesAcceptRoute = TeamInvitesAcceptRouteImport.update({
  id: '/team-invites/accept',
  path: '/team-invites/accept',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingsIdIndexLazyRoute = BookingsIdIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BookingsIdRoute,
} as any).lazy(() =>
  import('./routes/bookings/$id.index.lazy').then((d) => d.Route),
)
const BookingsIdBookAgainRoute = BookingsIdBookAgainRouteImport.update({
  id: '/book-again',
  path: '/book-again',
  getParentRoute: () => BookingsIdRoute,
} as any).lazy(() =>
  import('./routes/bookings/$id.book-again.lazy').then((d) => d.Route),
)
const BookingsIdRescheduleRoute = BookingsIdRescheduleRouteImport.update({
  id: '/reschedule',
  path: '/reschedule',
  getParentRoute: () => BookingsIdRoute,
} as any).lazy(() =>
  import('./routes/bookings/$id.reschedule.lazy').then((d) => d.Route),
)
const BusinessesSlugBookRoute = BusinessesSlugBookRouteImport.update({
  id: '/book',
  path: '/book',
  getParentRoute: () => BusinessesSlugRoute,
} as any).lazy(() =>
  import('./routes/businesses/$slug.book.lazy').then((d) => d.Route),
)
const DashboardBusinessSlugIndexLazyRoute =
  DashboardBusinessSlugIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardBusinessSlugRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/$businessSlug/index.lazy').then((d) => d.Route),
  )
const DashboardBusinessSlugCalendarRoute =
  DashboardBusinessSlugCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => DashboardBusinessSlugRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/$businessSlug/calendar.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardBusinessSlugClientsRoute =
  DashboardBusinessSlugClientsRouteImport.update({
    id: '/clients',
    path: '/clients',
    getParentRoute: () => DashboardBusinessSlugRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/$businessSlug/clients.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardBusinessSlugPosRoute =
  DashboardBusinessSlugPosRouteImport.update({
    id: '/pos',
    path: '/pos',
    getParentRoute: () => DashboardBusinessSlugRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/$businessSlug/pos.lazy').then((d) => d.Route),
  )
const DashboardBusinessSlugSettingsRoute =
  DashboardBusinessSlugSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => DashboardBusinessSlugRoute,
  } as any).lazy(() =>
    import('./routes/dashboard/$businessSlug/settings.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/for-pros': typeof ForProsRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/search': typeof SearchRoute
  '/verify-email': typeof VerifyEmailRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/phone': typeof AuthPhoneRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/bookings/$id': typeof BookingsIdRouteWithChildren
  '/businesses/$slug': typeof BusinessesSlugRouteWithChildren
  '/dashboard/$businessSlug': typeof DashboardBusinessSlugRouteWithChildren
  '/dashboard/calendar': typeof DashboardCalendarRoute
  '/dashboard/clients': typeof DashboardClientsRoute
  '/dashboard/pos': typeof DashboardPosRoute
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/discover/$category': typeof DiscoverCategoryRoute
  '/onboarding/business': typeof OnboardingBusinessRoute
  '/onboarding/complete': typeof OnboardingCompleteRoute
  '/onboarding/location': typeof OnboardingLocationRoute
  '/onboarding/new': typeof OnboardingNewRoute
  '/onboarding/select-business': typeof OnboardingSelectBusinessRoute
  '/onboarding/services': typeof OnboardingServicesRoute
  '/onboarding/sign-up': typeof OnboardingSignUpRoute
  '/onboarding/start': typeof OnboardingStartRoute
  '/onboarding/team-size': typeof OnboardingTeamSizeRoute
  '/onboarding/verify-phone': typeof OnboardingVerifyPhoneRoute
  '/team-invites/accept': typeof TeamInvitesAcceptRoute
  '/auth/callback': typeof AuthCallbackLazyRoute
  '/bookings/': typeof BookingsIndexRoute
  '/discover/': typeof DiscoverIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/dashboard/': typeof DashboardIndexLazyRoute
  '/bookings/$id/book-again': typeof BookingsIdBookAgainRoute
  '/bookings/$id/reschedule': typeof BookingsIdRescheduleRoute
  '/businesses/$slug/book': typeof BusinessesSlugBookRoute
  '/dashboard/$businessSlug/calendar': typeof DashboardBusinessSlugCalendarRoute
  '/dashboard/$businessSlug/clients': typeof DashboardBusinessSlugClientsRoute
  '/dashboard/$businessSlug/pos': typeof DashboardBusinessSlugPosRoute
  '/dashboard/$businessSlug/settings': typeof DashboardBusinessSlugSettingsRoute
  '/bookings/$id/': typeof BookingsIdIndexLazyRoute
  '/dashboard/$businessSlug/': typeof DashboardBusinessSlugIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/for-pros': typeof ForProsRoute
  '/search': typeof SearchRoute
  '/verify-email': typeof VerifyEmailRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/phone': typeof AuthPhoneRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/businesses/$slug': typeof BusinessesSlugRouteWithChildren
  '/dashboard/calendar': typeof DashboardCalendarRoute
  '/dashboard/clients': typeof DashboardClientsRoute
  '/dashboard/pos': typeof DashboardPosRoute
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/discover/$category': typeof DiscoverCategoryRoute
  '/onboarding/business': typeof OnboardingBusinessRoute
  '/onboarding/complete': typeof OnboardingCompleteRoute
  '/onboarding/location': typeof OnboardingLocationRoute
  '/onboarding/new': typeof OnboardingNewRoute
  '/onboarding/select-business': typeof OnboardingSelectBusinessRoute
  '/onboarding/services': typeof OnboardingServicesRoute
  '/onboarding/sign-up': typeof OnboardingSignUpRoute
  '/onboarding/start': typeof OnboardingStartRoute
  '/onboarding/team-size': typeof OnboardingTeamSizeRoute
  '/onboarding/verify-phone': typeof OnboardingVerifyPhoneRoute
  '/team-invites/accept': typeof TeamInvitesAcceptRoute
  '/auth/callback': typeof AuthCallbackLazyRoute
  '/bookings': typeof BookingsIndexRoute
  '/discover': typeof DiscoverIndexRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/dashboard': typeof DashboardIndexLazyRoute
  '/bookings/$id/book-again': typeof BookingsIdBookAgainRoute
  '/bookings/$id/reschedule': typeof BookingsIdRescheduleRoute
  '/businesses/$slug/book': typeof BusinessesSlugBookRoute
  '/dashboard/$businessSlug/calendar': typeof DashboardBusinessSlugCalendarRoute
  '/dashboard/$businessSlug/clients': typeof DashboardBusinessSlugClientsRoute
  '/dashboard/$businessSlug/pos': typeof DashboardBusinessSlugPosRoute
  '/dashboard/$businessSlug/settings': typeof DashboardBusinessSlugSettingsRoute
  '/bookings/$id': typeof BookingsIdIndexLazyRoute
  '/dashboard/$businessSlug': typeof DashboardBusinessSlugIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/for-pros': typeof ForProsRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/search': typeof SearchRoute
  '/verify-email': typeof VerifyEmailRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/phone': typeof AuthPhoneRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/bookings/$id': typeof BookingsIdRouteWithChildren
  '/businesses/$slug': typeof BusinessesSlugRouteWithChildren
  '/dashboard/$businessSlug': typeof DashboardBusinessSlugRouteWithChildren
  '/dashboard/calendar': typeof DashboardCalendarRoute
  '/dashboard/clients': typeof DashboardClientsRoute
  '/dashboard/pos': typeof DashboardPosRoute
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/discover/$category': typeof DiscoverCategoryRoute
  '/onboarding/business': typeof OnboardingBusinessRoute
  '/onboarding/complete': typeof OnboardingCompleteRoute
  '/onboarding/location': typeof OnboardingLocationRoute
  '/onboarding/new': typeof OnboardingNewRoute
  '/onboarding/select-business': typeof OnboardingSelectBusinessRoute
  '/onboarding/services': typeof OnboardingServicesRoute
  '/onboarding/sign-up': typeof OnboardingSignUpRoute
  '/onboarding/start': typeof OnboardingStartRoute
  '/onboarding/team-size': typeof OnboardingTeamSizeRoute
  '/onboarding/verify-phone': typeof OnboardingVerifyPhoneRoute
  '/team-invites/accept': typeof TeamInvitesAcceptRoute
  '/auth/callback': typeof AuthCallbackLazyRoute
  '/bookings/': typeof BookingsIndexRoute
  '/discover/': typeof DiscoverIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/dashboard/': typeof DashboardIndexLazyRoute
  '/bookings/$id/book-again': typeof BookingsIdBookAgainRoute
  '/bookings/$id/reschedule': typeof BookingsIdRescheduleRoute
  '/businesses/$slug/book': typeof BusinessesSlugBookRoute
  '/dashboard/$businessSlug/calendar': typeof DashboardBusinessSlugCalendarRoute
  '/dashboard/$businessSlug/clients': typeof DashboardBusinessSlugClientsRoute
  '/dashboard/$businessSlug/pos': typeof DashboardBusinessSlugPosRoute
  '/dashboard/$businessSlug/settings': typeof DashboardBusinessSlugSettingsRoute
  '/bookings/$id/': typeof BookingsIdIndexLazyRoute
  '/dashboard/$businessSlug/': typeof DashboardBusinessSlugIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/dashboard'
    | '/for-pros'
    | '/onboarding'
    | '/search'
    | '/verify-email'
    | '/auth/forgot-password'
    | '/auth/phone'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/bookings/$id'
    | '/businesses/$slug'
    | '/dashboard/$businessSlug'
    | '/dashboard/calendar'
    | '/dashboard/clients'
    | '/dashboard/pos'
    | '/dashboard/settings'
    | '/discover/$category'
    | '/onboarding/business'
    | '/onboarding/complete'
    | '/onboarding/location'
    | '/onboarding/new'
    | '/onboarding/select-business'
    | '/onboarding/services'
    | '/onboarding/sign-up'
    | '/onboarding/start'
    | '/onboarding/team-size'
    | '/onboarding/verify-phone'
    | '/team-invites/accept'
    | '/auth/callback'
    | '/bookings/'
    | '/discover/'
    | '/onboarding/'
    | '/dashboard/'
    | '/bookings/$id/book-again'
    | '/bookings/$id/reschedule'
    | '/businesses/$slug/book'
    | '/dashboard/$businessSlug/calendar'
    | '/dashboard/$businessSlug/clients'
    | '/dashboard/$businessSlug/pos'
    | '/dashboard/$businessSlug/settings'
    | '/bookings/$id/'
    | '/dashboard/$businessSlug/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/for-pros'
    | '/search'
    | '/verify-email'
    | '/auth/forgot-password'
    | '/auth/phone'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/businesses/$slug'
    | '/dashboard/calendar'
    | '/dashboard/clients'
    | '/dashboard/pos'
    | '/dashboard/settings'
    | '/discover/$category'
    | '/onboarding/business'
    | '/onboarding/complete'
    | '/onboarding/location'
    | '/onboarding/new'
    | '/onboarding/select-business'
    | '/onboarding/services'
    | '/onboarding/sign-up'
    | '/onboarding/start'
    | '/onboarding/team-size'
    | '/onboarding/verify-phone'
    | '/team-invites/accept'
    | '/auth/callback'
    | '/bookings'
    | '/discover'
    | '/onboarding'
    | '/dashboard'
    | '/bookings/$id/book-again'
    | '/bookings/$id/reschedule'
    | '/businesses/$slug/book'
    | '/dashboard/$businessSlug/calendar'
    | '/dashboard/$businessSlug/clients'
    | '/dashboard/$businessSlug/pos'
    | '/dashboard/$businessSlug/settings'
    | '/bookings/$id'
    | '/dashboard/$businessSlug'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/dashboard'
    | '/for-pros'
    | '/onboarding'
    | '/search'
    | '/verify-email'
    | '/auth/forgot-password'
    | '/auth/phone'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/bookings/$id'
    | '/businesses/$slug'
    | '/dashboard/$businessSlug'
    | '/dashboard/calendar'
    | '/dashboard/clients'
    | '/dashboard/pos'
    | '/dashboard/settings'
    | '/discover/$category'
    | '/onboarding/business'
    | '/onboarding/complete'
    | '/onboarding/location'
    | '/onboarding/new'
    | '/onboarding/select-business'
    | '/onboarding/services'
    | '/onboarding/sign-up'
    | '/onboarding/start'
    | '/onboarding/team-size'
    | '/onboarding/verify-phone'
    | '/team-invites/accept'
    | '/auth/callback'
    | '/bookings/'
    | '/discover/'
    | '/onboarding/'
    | '/dashboard/'
    | '/bookings/$id/book-again'
    | '/bookings/$id/reschedule'
    | '/businesses/$slug/book'
    | '/dashboard/$businessSlug/calendar'
    | '/dashboard/$businessSlug/clients'
    | '/dashboard/$businessSlug/pos'
    | '/dashboard/$businessSlug/settings'
    | '/bookings/$id/'
    | '/dashboard/$businessSlug/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  ForProsRoute: typeof ForProsRoute
  OnboardingRoute: typeof OnboardingRouteWithChildren
  SearchRoute: typeof SearchRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthPhoneRoute: typeof AuthPhoneRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  BookingsIdRoute: typeof BookingsIdRouteWithChildren
  BusinessesSlugRoute: typeof BusinessesSlugRouteWithChildren
  DiscoverCategoryRoute: typeof DiscoverCategoryRoute
  TeamInvitesAcceptRoute: typeof TeamInvitesAcceptRoute
  AuthCallbackLazyRoute: typeof AuthCallbackLazyRoute
  BookingsIndexRoute: typeof BookingsIndexRoute
  DiscoverIndexRoute: typeof DiscoverIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/for-pros': {
      id: '/for-pros'
      path: '/for-pros'
      fullPath: '/for-pros'
      preLoaderRoute: typeof ForProsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/phone': {
      id: '/auth/phone'
      path: '/auth/phone'
      fullPath: '/auth/phone'
      preLoaderRoute: typeof AuthPhoneRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/auth/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sign-up': {
      id: '/auth/sign-up'
      path: '/auth/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookings/': {
      id: '/bookings/'
      path: '/bookings'
      fullPath: '/bookings/'
      preLoaderRoute: typeof BookingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookings/$id': {
      id: '/bookings/$id'
      path: '/bookings/$id'
      fullPath: '/bookings/$id'
      preLoaderRoute: typeof BookingsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/businesses/$slug': {
      id: '/businesses/$slug'
      path: '/businesses/$slug'
      fullPath: '/businesses/$slug'
      preLoaderRoute: typeof BusinessesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexLazyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/$businessSlug': {
      id: '/dashboard/$businessSlug'
      path: '/$businessSlug'
      fullPath: '/dashboard/$businessSlug'
      preLoaderRoute: typeof DashboardBusinessSlugRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/calendar': {
      id: '/dashboard/calendar'
      path: '/calendar'
      fullPath: '/dashboard/calendar'
      preLoaderRoute: typeof DashboardCalendarRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/clients': {
      id: '/dashboard/clients'
      path: '/clients'
      fullPath: '/dashboard/clients'
      preLoaderRoute: typeof DashboardClientsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/pos': {
      id: '/dashboard/pos'
      path: '/pos'
      fullPath: '/dashboard/pos'
      preLoaderRoute: typeof DashboardPosRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/settings': {
      id: '/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof DashboardSettingsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/discover/': {
      id: '/discover/'
      path: '/discover'
      fullPath: '/discover/'
      preLoaderRoute: typeof DiscoverIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/discover/$category': {
      id: '/discover/$category'
      path: '/discover/$category'
      fullPath: '/discover/$category'
      preLoaderRoute: typeof DiscoverCategoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/business': {
      id: '/onboarding/business'
      path: '/business'
      fullPath: '/onboarding/business'
      preLoaderRoute: typeof OnboardingBusinessRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/complete': {
      id: '/onboarding/complete'
      path: '/complete'
      fullPath: '/onboarding/complete'
      preLoaderRoute: typeof OnboardingCompleteRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/location': {
      id: '/onboarding/location'
      path: '/location'
      fullPath: '/onboarding/location'
      preLoaderRoute: typeof OnboardingLocationRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/new': {
      id: '/onboarding/new'
      path: '/new'
      fullPath: '/onboarding/new'
      preLoaderRoute: typeof OnboardingNewRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/select-business': {
      id: '/onboarding/select-business'
      path: '/select-business'
      fullPath: '/onboarding/select-business'
      preLoaderRoute: typeof OnboardingSelectBusinessRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/services': {
      id: '/onboarding/services'
      path: '/services'
      fullPath: '/onboarding/services'
      preLoaderRoute: typeof OnboardingServicesRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/sign-up': {
      id: '/onboarding/sign-up'
      path: '/sign-up'
      fullPath: '/onboarding/sign-up'
      preLoaderRoute: typeof OnboardingSignUpRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/start': {
      id: '/onboarding/start'
      path: '/start'
      fullPath: '/onboarding/start'
      preLoaderRoute: typeof OnboardingStartRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/team-size': {
      id: '/onboarding/team-size'
      path: '/team-size'
      fullPath: '/onboarding/team-size'
      preLoaderRoute: typeof OnboardingTeamSizeRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/verify-phone': {
      id: '/onboarding/verify-phone'
      path: '/verify-phone'
      fullPath: '/onboarding/verify-phone'
      preLoaderRoute: typeof OnboardingVerifyPhoneRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/team-invites/accept': {
      id: '/team-invites/accept'
      path: '/team-invites/accept'
      fullPath: '/team-invites/accept'
      preLoaderRoute: typeof TeamInvitesAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookings/$id/': {
      id: '/bookings/$id/'
      path: '/'
      fullPath: '/bookings/$id/'
      preLoaderRoute: typeof BookingsIdIndexLazyRouteImport
      parentRoute: typeof BookingsIdRoute
    }
    '/bookings/$id/book-again': {
      id: '/bookings/$id/book-again'
      path: '/book-again'
      fullPath: '/bookings/$id/book-again'
      preLoaderRoute: typeof BookingsIdBookAgainRouteImport
      parentRoute: typeof BookingsIdRoute
    }
    '/bookings/$id/reschedule': {
      id: '/bookings/$id/reschedule'
      path: '/reschedule'
      fullPath: '/bookings/$id/reschedule'
      preLoaderRoute: typeof BookingsIdRescheduleRouteImport
      parentRoute: typeof BookingsIdRoute
    }
    '/businesses/$slug/book': {
      id: '/businesses/$slug/book'
      path: '/book'
      fullPath: '/businesses/$slug/book'
      preLoaderRoute: typeof BusinessesSlugBookRouteImport
      parentRoute: typeof BusinessesSlugRoute
    }
    '/dashboard/$businessSlug/': {
      id: '/dashboard/$businessSlug/'
      path: '/'
      fullPath: '/dashboard/$businessSlug/'
      preLoaderRoute: typeof DashboardBusinessSlugIndexLazyRouteImport
      parentRoute: typeof DashboardBusinessSlugRoute
    }
    '/dashboard/$businessSlug/calendar': {
      id: '/dashboard/$businessSlug/calendar'
      path: '/calendar'
      fullPath: '/dashboard/$businessSlug/calendar'
      preLoaderRoute: typeof DashboardBusinessSlugCalendarRouteImport
      parentRoute: typeof DashboardBusinessSlugRoute
    }
    '/dashboard/$businessSlug/clients': {
      id: '/dashboard/$businessSlug/clients'
      path: '/clients'
      fullPath: '/dashboard/$businessSlug/clients'
      preLoaderRoute: typeof DashboardBusinessSlugClientsRouteImport
      parentRoute: typeof DashboardBusinessSlugRoute
    }
    '/dashboard/$businessSlug/pos': {
      id: '/dashboard/$businessSlug/pos'
      path: '/pos'
      fullPath: '/dashboard/$businessSlug/pos'
      preLoaderRoute: typeof DashboardBusinessSlugPosRouteImport
      parentRoute: typeof DashboardBusinessSlugRoute
    }
    '/dashboard/$businessSlug/settings': {
      id: '/dashboard/$businessSlug/settings'
      path: '/settings'
      fullPath: '/dashboard/$businessSlug/settings'
      preLoaderRoute: typeof DashboardBusinessSlugSettingsRouteImport
      parentRoute: typeof DashboardBusinessSlugRoute
    }
  }
}

interface DashboardBusinessSlugRouteChildren {
  DashboardBusinessSlugCalendarRoute: typeof DashboardBusinessSlugCalendarRoute
  DashboardBusinessSlugClientsRoute: typeof DashboardBusinessSlugClientsRoute
  DashboardBusinessSlugPosRoute: typeof DashboardBusinessSlugPosRoute
  DashboardBusinessSlugSettingsRoute: typeof DashboardBusinessSlugSettingsRoute
  DashboardBusinessSlugIndexLazyRoute: typeof DashboardBusinessSlugIndexLazyRoute
}

const DashboardBusinessSlugRouteChildren: DashboardBusinessSlugRouteChildren = {
  DashboardBusinessSlugCalendarRoute: DashboardBusinessSlugCalendarRoute,
  DashboardBusinessSlugClientsRoute: DashboardBusinessSlugClientsRoute,
  DashboardBusinessSlugPosRoute: DashboardBusinessSlugPosRoute,
  DashboardBusinessSlugSettingsRoute: DashboardBusinessSlugSettingsRoute,
  DashboardBusinessSlugIndexLazyRoute: DashboardBusinessSlugIndexLazyRoute,
}

const DashboardBusinessSlugRouteWithChildren =
  DashboardBusinessSlugRoute._addFileChildren(
    DashboardBusinessSlugRouteChildren,
  )

interface DashboardRouteChildren {
  DashboardBusinessSlugRoute: typeof DashboardBusinessSlugRouteWithChildren
  DashboardCalendarRoute: typeof DashboardCalendarRoute
  DashboardClientsRoute: typeof DashboardClientsRoute
  DashboardPosRoute: typeof DashboardPosRoute
  DashboardSettingsRoute: typeof DashboardSettingsRoute
  DashboardIndexLazyRoute: typeof DashboardIndexLazyRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardBusinessSlugRoute: DashboardBusinessSlugRouteWithChildren,
  DashboardCalendarRoute: DashboardCalendarRoute,
  DashboardClientsRoute: DashboardClientsRoute,
  DashboardPosRoute: DashboardPosRoute,
  DashboardSettingsRoute: DashboardSettingsRoute,
  DashboardIndexLazyRoute: DashboardIndexLazyRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

interface OnboardingRouteChildren {
  OnboardingBusinessRoute: typeof OnboardingBusinessRoute
  OnboardingCompleteRoute: typeof OnboardingCompleteRoute
  OnboardingLocationRoute: typeof OnboardingLocationRoute
  OnboardingNewRoute: typeof OnboardingNewRoute
  OnboardingSelectBusinessRoute: typeof OnboardingSelectBusinessRoute
  OnboardingServicesRoute: typeof OnboardingServicesRoute
  OnboardingSignUpRoute: typeof OnboardingSignUpRoute
  OnboardingStartRoute: typeof OnboardingStartRoute
  OnboardingTeamSizeRoute: typeof OnboardingTeamSizeRoute
  OnboardingVerifyPhoneRoute: typeof OnboardingVerifyPhoneRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingBusinessRoute: OnboardingBusinessRoute,
  OnboardingCompleteRoute: OnboardingCompleteRoute,
  OnboardingLocationRoute: OnboardingLocationRoute,
  OnboardingNewRoute: OnboardingNewRoute,
  OnboardingSelectBusinessRoute: OnboardingSelectBusinessRoute,
  OnboardingServicesRoute: OnboardingServicesRoute,
  OnboardingSignUpRoute: OnboardingSignUpRoute,
  OnboardingStartRoute: OnboardingStartRoute,
  OnboardingTeamSizeRoute: OnboardingTeamSizeRoute,
  OnboardingVerifyPhoneRoute: OnboardingVerifyPhoneRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

interface BookingsIdRouteChildren {
  BookingsIdBookAgainRoute: typeof BookingsIdBookAgainRoute
  BookingsIdRescheduleRoute: typeof BookingsIdRescheduleRoute
  BookingsIdIndexLazyRoute: typeof BookingsIdIndexLazyRoute
}

const BookingsIdRouteChildren: BookingsIdRouteChildren = {
  BookingsIdBookAgainRoute: BookingsIdBookAgainRoute,
  BookingsIdRescheduleRoute: BookingsIdRescheduleRoute,
  BookingsIdIndexLazyRoute: BookingsIdIndexLazyRoute,
}

const BookingsIdRouteWithChildren = BookingsIdRoute._addFileChildren(
  BookingsIdRouteChildren,
)

interface BusinessesSlugRouteChildren {
  BusinessesSlugBookRoute: typeof BusinessesSlugBookRoute
}

const BusinessesSlugRouteChildren: BusinessesSlugRouteChildren = {
  BusinessesSlugBookRoute: BusinessesSlugBookRoute,
}

const BusinessesSlugRouteWithChildren = BusinessesSlugRoute._addFileChildren(
  BusinessesSlugRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  DashboardRoute: DashboardRouteWithChildren,
  ForProsRoute: ForProsRoute,
  OnboardingRoute: OnboardingRouteWithChildren,
  SearchRoute: SearchRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthPhoneRoute: AuthPhoneRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  BookingsIdRoute: BookingsIdRouteWithChildren,
  BusinessesSlugRoute: BusinessesSlugRouteWithChildren,
  DiscoverCategoryRoute: DiscoverCategoryRoute,
  TeamInvitesAcceptRoute: TeamInvitesAcceptRoute,
  AuthCallbackLazyRoute: AuthCallbackLazyRoute,
  BookingsIndexRoute: BookingsIndexRoute,
  DiscoverIndexRoute: DiscoverIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
